import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "@mui/material/Avatar";
import { isEmail, isStrongPassword } from "validator";
import { Link } from "react-router-dom";

import {
  Divider,
  CssBaseline,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  Box,
  Typography,
  Container,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { LockOutlined, Google } from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { ACTIONS as MAIN_ACTIONS } from "../../../redux/main";

const defaultTheme = createTheme();

export default function SignIn() {
  const dispatch = useDispatch();
  const { api } = useSelector((state) => state.main);

  const [isFormValid, setIsFormValid] = useState({
    email: "",
    password: "",
  });

  const onSubmitHandler = (event) => {
    event.preventDefault();

    const form = new FormData(event.currentTarget);
    const email = form.get("email") || "";
    const password = form.get("password") || "";

    const isValidEmail = isEmail(email);
    const isValidPassword = isStrongPassword(password, {
      minSymbols: 0,
      minLength: 7,
    });

    if (isValidEmail && isValidPassword) {
      dispatch(MAIN_ACTIONS.logInEmail({ email, password }));
    }

    setIsFormValid({
      email: isValidEmail ? "" : "Email no válido",
      password: isValidPassword ? "" : "La constraseña no es válida",
    });
  };

  const onGoogleSignInHandler = (event) => {
    event.preventDefault();
    dispatch(MAIN_ACTIONS.signInWithGoogle({ redirect: "/home" }));
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlined />
          </Avatar>
          <Typography component="h1" variant="h5">
            Accede al área de socios
          </Typography>
          <Box
            component="form"
            onSubmit={onSubmitHandler}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              error={isFormValid.email || false}
              helperText={isFormValid.email}
              onFocus={() => setIsFormValid((p) => ({ ...p, email: "" }))}
              disabled={!!api.loading}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
              error={isFormValid.password || false}
              helperText={isFormValid.password}
              onFocus={() => setIsFormValid((p) => ({ ...p, password: "" }))}
              disabled={!!api.loading}
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Recordar"
              disabled={!!api.loading}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={
                !!(api.loading || isFormValid.email || isFormValid.password)
              }
            >
              Acceder
            </Button>

            <Divider orientation="horizontal" sx={{ mt: 4, mb: 4 }} />

            <LoadingButton
              type="text"
              fullWidth
              variant="outlined"
              size="large"
              startIcon={<Google />}
              onClick={onGoogleSignInHandler}
              loading={api.loading}
              disabled={!!api.loading}
            >
              Google
            </LoadingButton>

            <Grid container>
              <Grid item xs></Grid>
              <Grid item>
                {/* cambiar....  */}
                <Link to="/sign-in">¿No tienes cuenta?</Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
